import React, { memo } from 'react'
import CommonDialog from '../../../common/components/dialog/CommonDialog'
import styles from './PauseProductDialog.module.scss'
import { SolarProduct } from '../../../model/solar-product/solar-product'
import { useDispatch } from 'react-redux'
import { showLoader, hideLoader } from '../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'
import { usePauseProductMutation } from '../../../service/solar-product-service'
import { getErrorMessage } from '../../../utils/error-handler'

type Props = {
    product: SolarProduct
    onCloseDialog: () => void
    onProductPaused: () => void
}

const PauseProductDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();
    const [pauseProduct, { isLoading }] = usePauseProductMutation();
    const handlePauseProduct = async () => {
        
        try {
            dispatch(showLoader());
            await pauseProduct(props.product.id!).unwrap();
            props.onProductPaused();
            toast.success(`Product ${props.product.isDeactivated ? 'unpaused' : 'paused'} successfully`)
        } catch (error: any) {
            toast.error(getErrorMessage(error.data) ?? 'An Error occurred');
            
        } finally {
            dispatch(hideLoader());
            props.onCloseDialog();
        }
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={styles.container}>
                <div className={styles.title}>
                    Are you sure you want to {
                        props.product.isDeactivated ? 'unpause' : 'pause'
                    } this product?
                </div>
                <div className={styles.description}>
                    {
                        props.product.isDeactivated ? 'Unpausing' : 'Pausing'
                    } a product will make it {
                        props.product.isDeactivated ? 'available' : 'unavailable'
                    } for purchase by customers.
                </div>

                <div className={styles.buttonContainer}>
                    <button className={`standardButton ${styles.button} ${styles.pauseButton}`}  disabled={isLoading} onClick={handlePauseProduct}>{
                        props.product.isDeactivated ? 'Unpause' : 'Pause'
                    }</button>
                    <button className={`standardButton ${styles.button}`} onClick={cancel}>Cancel</button>
                </div>
            </div>
        </CommonDialog>
    )
})

export default PauseProductDialog